import React, { PropsWithChildren } from 'react';
import css from './GMInfoGridColumn.module.scss';
import { GoMotoComponent } from '../../../API/GoMoto.types';

export const GMInfoGridColumn: GoMotoComponent<PropsWithChildren> = (props) => (
    <div className={css.infoGridColumn}>
        {React.Children.map(props.children, (child, index) => (
            <div
                key={index}
                role={'presentation'}
                className={css.infoGridColumnContent}
            >
                {child}
            </div>
        ))}
    </div>
);
